import { TranslationType } from 'generated/graphql';
import { createContext, useMemo } from 'react';
import {
  PasteFromClipboardHook,
  getClipBoardHook,
  usePasteFromClipboardTraining
} from './usePasteFromClipboard';
import { NotSelectedTranslationType } from 'stores/interfaces/CommonQueryState';

interface CreateQueryProviderProps {
  type: TranslationType | NotSelectedTranslationType;
  children: React.ReactNode;
}

interface CreateQueryContextProps {
  useClipboardStore: PasteFromClipboardHook;
}

export const CreateQueryContext = createContext<CreateQueryContextProps>({
  useClipboardStore: usePasteFromClipboardTraining
});

export const CreateQueryProvider: React.FC<CreateQueryProviderProps> = (props) => {
  const { type, children } = props;
  const useClipboardStore = useMemo(() => ({ useClipboardStore: getClipBoardHook(type) }), [type]);
  return (
    <CreateQueryContext.Provider value={useClipboardStore}>{children}</CreateQueryContext.Provider>
  );
};
